/**
 * Signed in, but not for this — distinct from the login page, because a password box would imply a
 * credential problem. It names the Base Portal roles the user does hold (§6.7), which is the
 * sentence they repeat to whoever grants access.
 */

import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';
import { useI18n } from '@/lib/i18n';

export default function NotAuthorisedPage() {
  const { text } = useI18n();
  const { user } = useAuth();

  return (
    <div className="mx-auto w-full max-w-md space-y-6 py-16 text-center">
      <FontAwesomeIcon icon={faLock} className="text-3xl text-muted-foreground" aria-hidden />

      <div className="space-y-2">
        <h1 className="text-xl font-semibold tracking-tight">
          {text('Your roles don’t cover this report')}
        </h1>
        <p className="text-sm text-muted-foreground">
          Which reports you see follows your Base Portal roles. Ask your manager to request the
          role that covers it, then sign in again.
        </p>
      </div>

      {user !== null && (
        <p className="text-sm text-muted-foreground">
          You are signed in as <span className="font-medium text-foreground">{user.username}</span>
          {user.roles.length > 0 ? (
            <>
              {' '}
              with <span className="font-medium text-foreground">{user.roles.join(', ')}</span>.
            </>
          ) : (
            ' with no reporting roles assigned.'
          )}
        </p>
      )}

      <Button asChild>
        <Link to="/">{text('Go to overview')}</Link>
      </Button>
    </div>
  );
}
